import { gql } from "@apollo/client";


export const CREATE_USER = gql`
mutation CreateOrUpdateUser($input: UserInput!) {
  createOrUpdateUser(input: $input) {
    success
    message
    error
    token
    user {
      id
      username
      email
      password_hash
      user_type
      type_code
      status_code
      created_date
      modified_date
    }
  }
}
`